var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"raised":""}},[_c('v-toolbar',{attrs:{"dark":"","color":"primary","flat":""}},[_c('v-toolbar-title',[_vm._v("Password reset")])],1),_c('v-card-text',[_c('div',{staticClass:"fullwidth"},[_c('p',[_vm._v("Choose a new password below")]),_c('password-reset-form',{on:{"success":_vm.success}})],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }